export * from './article.model';
export * from '../../core/models/category.model'
export * from './article.service';




// WEBPACK FOOTER //
// ./src/app/news/shared/index.ts